const translations: Record<string, string> = {
  'common:siteName': 'أدوات PDF مجانية',
  'common:nav.home': 'الرئيسية',
  'common:nav.pdfToWord': 'PDF إلى Word',
  'common:nav.pdfToExcel': 'PDF إلى Excel',
  'common:nav.pdfToPpt': 'PDF إلى PPT',
  'common:nav.imageConvert': 'تحويل الصور',
  'common:nav.pdfTools': 'أدوات PDF',
  'common:nav.tutorials': 'الدروس',
  'common:nav.faq': 'الأسئلة الشائعة',

  'common:footer.description': 'أفضل أدوات PDF المجانية لجميع احتياجاتك. بدون تسجيل.',
  'common:footer.quickLinks': 'روابط سريعة',
  'common:footer.about': 'حول',
  'common:footer.aboutUs': 'معلومات عنا',
  'common:footer.tutorials': 'دروس تعليمية',
  'common:footer.faq': 'الأسئلة الشائعة',
  'common:footer.privacyPolicy': 'سياسة الخصوصية',
  'common:footer.subscribe': 'النشرة الإخبارية',
  'common:footer.subscribeNote': 'احصل على أحدث النصائح والتحديثات.',
  'common:footer.subscribePlaceholder': 'أدخل بريدك الإلكتروني',
  'common:footer.subscribeButton': 'اشترك',
  'common:footer.subscribing': 'جاري الاشتراك...',
  'common:footer.subscribeSuccess': '✓ تم الاشتراك بنجاح!',
  'common:footer.subscribeFailed': 'فشل الاشتراك، حاول مرة أخرى.',
  'common:footer.subscribeError': 'خطأ في الشبكة، حاول مرة أخرى.',
  'common:footer.adSpace': 'مساحة إعلانية',
  'common:footer.copyright': '© 2024 أدوات PDF مجانية. جميع الحقوق محفوظة.',

  'common:features.pdfToDoc': 'PDF إلى مستندات',
  'common:features.pdfToDocDesc': 'حول PDF إلى Word وExcel وPPT وتنسيقات قابلة للتحرير.',
  'common:features.imageToPdf': 'صورة إلى PDF',
  'common:features.imageToPdfDesc': 'ادمج صور متعددة في ملف PDF واحد بسهولة.',
  'common:features.pdfMerge': 'دمج وتقسيم PDF',
  'common:features.pdfMergeDesc': 'ادمج عدة ملفات PDF أو قسّم ملفاً واحداً إلى ملفات منفصلة.',
  'common:features.startConvert': 'ابدأ التحويل',
  'common:features.useNow': 'استخدم الآن',
  'common:features.mostPopular': 'الأكثر شعبية',

  'home:hero.title': 'أدوات PDF مجانية عبر الإنترنت',
  'home:hero.subtitle': 'حوّل وحرّر وأدر ملفات PDF بسهولة. لا يلزم تسجيل، مجاني 100٪!',
  'home:hero.free': 'مجاني للأبد',
  'home:hero.noRegistration': 'بدون تسجيل',
  'home:hero.secure': 'آمن وخاص',
  'home:hero.startConverting': 'ابدأ التحويل',
  'home:hero.viewAllTools': 'عرض جميع الأدوات',
  'home:hero.stats.users': 'مستخدم سعيد',
  'home:hero.stats.conversions': 'ملف تم تحويله',
  'home:hero.stats.rating': 'تقييم المستخدمين',

  'home:allTools.title': 'جميع أدوات PDF',
  'home:allTools.subtitle': 'كل ما تحتاجه للعمل مع ملفات PDF، مجاناً تماماً.',
  'home:allTools.tryNow': 'جرّب الآن',
  'home:tools.pdfToWord.name': 'PDF إلى Word',
  'home:tools.pdfToWord.description': 'حوّل PDF إلى مستندات Word قابلة للتحرير.',
  'home:tools.pdfToExcel.name': 'PDF إلى Excel',
  'home:tools.pdfToExcel.description': 'استخرج الجداول من PDF إلى جداول بيانات Excel.',
  'home:tools.pdfToPpt.name': 'PDF إلى PPT',
  'home:tools.pdfToPpt.description': 'حوّل PDF إلى عروض PowerPoint تقديمية.',
  'home:tools.pdfToImage.name': 'PDF إلى صورة',
  'home:tools.pdfToImage.description': 'حوّل صفحات PDF إلى صور JPG أو PNG.',
  'home:tools.imageToPdf.name': 'صورة إلى PDF',
  'home:tools.imageToPdf.description': 'ادمج الصور في ملف PDF واحد.',
  'home:tools.mergePdf.name': 'دمج PDF',
  'home:tools.mergePdf.description': 'ادمج عدة ملفات PDF في ملف واحد.',
  'home:tools.splitPdf.name': 'تقسيم PDF',
  'home:tools.splitPdf.description': 'استخرج صفحات من ملف PDF.',
  'home:tools.compressPdf.name': 'ضغط PDF',
  'home:tools.compressPdf.description': 'قلّل حجم ملف PDF دون فقدان الجودة.',

  'home:whyUs.title': 'لماذا تختارنا؟',
  'home:whyUs.subtitle': 'نقدم أفضل أدوات PDF المجانية بدون رسوم خفية أو تسجيل.',
  'home:whyUs.free.title': '100٪ مجاني',
  'home:whyUs.free.description': 'جميع الأدوات مجانية تماماً. لا رسوم خفية، لا اشتراكات.',
  'home:whyUs.fast.title': 'سريع للغاية',
  'home:whyUs.fast.description': 'تعالج خوادمنا ملفاتك في ثوانٍ.',
  'home:whyUs.secure.title': 'آمن وخاص',
  'home:whyUs.secure.description': 'يتم حذف ملفاتك تلقائياً بعد التحويل.',
  'home:whyUs.easy.title': 'سهل الاستخدام',
  'home:whyUs.easy.description': 'واجهة سحب وإفلات بسيطة، لا تحتاج مهارات تقنية.',
  'home:whyUs.cta.title': 'هل أنت مستعد للبدء؟',
  'home:whyUs.cta.description': 'انضم إلى ملايين المستخدمين الذين يثقون بأدواتنا المجانية يومياً.',
  'home:whyUs.cta.button': 'جرّب مجاناً الآن',

  'home:testimonials.title': 'ماذا يقول المستخدمون',
  'home:testimonials.subtitle': 'موثوق به من قبل ملايين المستخدمين حول العالم.',
  'home:testimonials.trustedBy': 'موثوق ومعتمد من قبل',
  'home:testimonials.badges.secure': 'SSL آمن',
  'home:testimonials.badges.verified': 'تم التحقق منه',
  'home:testimonials.badges.award': 'أفضل أداة',
  'home:testimonials.user1.name': 'سارة جونسون',
  'home:testimonials.user1.role': 'مدير تسويق',
  'home:testimonials.user1.content': 'هذه أفضل أداة PDF مجانية استخدمتها. سريعة وموثوقة ولا تحتاج تسجيلاً مزعجاً!',
  'home:testimonials.user2.name': 'إيميلي تشن',
  'home:testimonials.user2.role': 'مصممة مستقلة',
  'home:testimonials.user2.content': 'أحوّل ملفات PDF إلى Word يومياً لعملائي. هذه الأداة توفر وقتاً كثيراً وهي مجانية تماماً!',
  'home:testimonials.user3.name': 'مايكل توريس',
  'home:testimonials.user3.role': 'محلل أعمال',
  'home:testimonials.user3.content': 'ميزة PDF إلى Excel دقيقة بشكل لا يصدق. تستخرج الجداول بشكل مثالي في كل مرة.',

  'home:ads.topBanner': 'إعلان',
  'home:ads.middleBanner': 'إعلان',

  'upload:dragDrop': 'اسحب وأفلت ملف PDF الخاص بك هنا',
  'upload:or': 'أو',
  'upload:selectFile': 'اختر ملف',
  'upload:processing': 'جاري المعالجة...',
  'upload:converting': 'جاري تحويل ملفك...',
  'upload:done': 'تم!',
  'upload:success': 'تم تحويل ملفك بنجاح',
  'upload:download': 'تحميل الملف',
  'upload:convertAnother': 'تحويل ملف آخر',
  'upload:fileSize': 'الحد الأقصى لحجم الملف: 10 ميجابايت',
  'upload:supportedFormats': 'التنسيقات المدعومة',

  'pdfToWord:title': 'PDF إلى Word',
  'pdfToWord:description': 'حوّل ملفات PDF إلى مستندات Word قابلة للتحرير مجاناً',
  'pdfToWord:feature1.title': 'تحويل سريع',
  'pdfToWord:feature1.desc': 'حوّل PDF إلى Word في ثوانٍ',
  'pdfToWord:feature2.title': 'جودة عالية',
  'pdfToWord:feature2.desc': 'احتفظ بالتنسيق والتخطيط الأصلي',
  'pdfToWord:feature3.title': '100٪ مجاني',
  'pdfToWord:feature3.desc': 'لا يلزم التسجيل أو الدفع',
  'pdfToWord:howTo.title': 'كيفية الاستخدام',
  'pdfToWord:howTo.step1': 'قم بتحميل ملف PDF',
  'pdfToWord:howTo.step2': 'انتظر التحويل',
  'pdfToWord:howTo.step3': 'قم بتنزيل ملف Word',

  'pdfToExcel:title': 'PDF إلى Excel',
  'pdfToExcel:description': 'حوّل جداول PDF إلى جداول بيانات Excel قابلة للتحرير',
  'pdfToExcel:feature1.title': 'استخراج الجداول',
  'pdfToExcel:feature1.desc': 'استخرج الجداول من PDF تلقائياً',
  'pdfToExcel:feature2.title': 'بيانات دقيقة',
  'pdfToExcel:feature2.desc': 'احتفظ ببنية البيانات الأصلية',
  'pdfToExcel:feature3.title': 'سهل الاستخدام',
  'pdfToExcel:feature3.desc': 'واجهة بسيطة وبديهية',
  'pdfToExcel:howTo.title': 'كيفية الاستخدام',
  'pdfToExcel:howTo.step1': 'قم بتحميل ملف PDF يحتوي على جداول',
  'pdfToExcel:howTo.step2': 'سيقوم النظام باستخراج الجداول',
  'pdfToExcel:howTo.step3': 'قم بتنزيل ملف Excel',

  'pdfToPpt:title': 'PDF إلى PowerPoint',
  'pdfToPpt:description': 'حوّل PDF إلى عروض PowerPoint قابلة للتحرير',
  'pdfToPpt:feature1.title': 'تحويل الشرائح',
  'pdfToPpt:feature1.desc': 'كل صفحة PDF تصبح شريحة PPT',
  'pdfToPpt:feature2.title': 'قابل للتحرير',
  'pdfToPpt:feature2.desc': 'قم بتحرير النص والصور بعد التحويل',
  'pdfToPpt:feature3.title': 'آمن وخاص',
  'pdfToPpt:feature3.desc': 'يتم حذف ملفاتك بعد التحويل',
  'pdfToPpt:howTo.title': 'كيفية الاستخدام',
  'pdfToPpt:howTo.step1': 'حدد ملف PDF',
  'pdfToPpt:howTo.step2': 'حوّل إلى تنسيق PPT',
  'pdfToPpt:howTo.step3': 'قم بتنزيل العرض التقديمي',

  'imageConvert:title': 'محوّل الصور',
  'imageConvert:description': 'حوّل الصور إلى PDF أو PDF إلى صور بسهولة',
  'imageConvert:feature1.title': 'متعدد التنسيقات',
  'imageConvert:feature1.desc': 'يدعم JPG وPNG وBMP وGIF',
  'imageConvert:feature2.title': 'تحويل دفعي',
  'imageConvert:feature2.desc': 'حوّل عدة صور في وقت واحد',
  'imageConvert:feature3.title': 'جودة محفوظة',
  'imageConvert:feature3.desc': 'لا فقدان في جودة الصورة',
  'imageConvert:howTo.title': 'كيفية الاستخدام',
  'imageConvert:howTo.step1': 'قم بتحميل الصور أو PDF',
  'imageConvert:howTo.step2': 'اختر تنسيق الإخراج',
  'imageConvert:howTo.step3': 'قم بتنزيل الملفات المحوّلة',

  'pdfToolsPage:title': 'أدوات PDF الكاملة',
  'pdfToolsPage:description': 'ادمج وقسّم واضغط وحرّر ملفات PDF',
  'pdfToolsPage:feature1.title': 'دمج PDF',
  'pdfToolsPage:feature1.desc': 'ادمج عدة ملفات PDF في ملف واحد',
  'pdfToolsPage:feature2.title': 'تقسيم PDF',
  'pdfToolsPage:feature2.desc': 'استخرج صفحات من PDF',
  'pdfToolsPage:feature3.title': 'ضغط PDF',
  'pdfToolsPage:feature3.desc': 'قلّل حجم ملف PDF',
  'pdfToolsPage:howTo.title': 'كيفية الاستخدام',
  'pdfToolsPage:howTo.step1': 'اختر الأداة التي تحتاجها',
  'pdfToolsPage:howTo.step2': 'قم بتحميل ملف PDF',
  'pdfToolsPage:howTo.step3': 'قم بتنزيل النتيجة',

  'upload.dragDrop': 'اسحب وأفلت ملف PDF الخاص بك هنا',
  'upload.or': 'أو',
  'upload.selectFile': 'اختر ملف PDF',
  'upload.fileSize': 'الحد الأقصى لحجم الملف: 20 ميجابايت',
  'upload.uploading': 'جاري الرفع...',
  'upload.processing': 'جاري المعالجة...',
  'upload.converting': 'جاري التحويل...',
  'upload.preparing': 'جاري تحضير التنزيل...',
  'upload.done': 'اكتمل التحويل!',
  'upload.download': 'تحميل',
  'upload.convertAnother': 'تحويل ملف آخر',
  'upload.convertedTo': 'تم التحويل إلى',
  'upload.error': 'فشل التحويل',
  'upload.retry': 'إعادة المحاولة',
  'upload.selectAnother': 'اختر ملف آخر',
  'upload.fileTooLarge': 'حجم الملف يتجاوز حد 20 ميجابايت',
  'upload.invalidFormat': 'تنسيق الملف غير صالح',
  'upload.networkError': 'خطأ في الشبكة، يرجى المحاولة مرة أخرى',
  'upload.conversionFailed': 'فشل التحويل، يرجى المحاولة مرة أخرى',
  'upload.howItWorks': 'كيف يعمل',
  'upload.step1': 'رفع الملف',
  'upload.step1Desc': 'اختر أو اسحب ملف PDF الخاص بك',
  'upload.step2': 'تحويل',
  'upload.step2Desc': 'نقوم بمعالجة ملفك تلقائيًا',
  'upload.step3': 'تحميل',
  'upload.step3Desc': 'احصل على ملفك المحول على الفور',
  'upload.downloading': 'جاري تحضير التنزيل...',
  'upload.progress': 'التقدم: {percent}%',

  'imageConvert.pdfToImage': 'PDF إلى صورة',
  'imageConvert.imageToPdf': 'صورة إلى PDF',
  'imageConvert.selectImages': 'اختر الصور',
  'imageConvert.multipleFilesHint': 'يدعم دمج صور متعددة في ملف PDF واحد',
  'imageConvert.processingFiles': 'معالجة {count} ملف...',

  'pdfToPpt.feature1': 'الحفاظ على التخطيط',
  'pdfToPpt.feature2': 'الاحتفاظ بالصور',
  'pdfToPpt.feature3': 'عرض تقديمي قابل للتحرير',
};

export default translations;
